<template>
  <div id="content-actionbar" class="flex w-full">
    <div class="flex flex-wrap border d-theme-dark-bg items-center w-full px-4">
      <div v-show="isSearchView()">
        <document-search-view></document-search-view>
      </div>
      <div v-show="!isSearchView()">
        <document-path-view></document-path-view>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";

import DocumentSearchView from "./components/DocumentActionbarSearchView"
import DocumentPathView from "./components/DocumentActionbarPathView"


const {
  mapState: mapStateOfenterpriseDocumentManager,
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  name: "DocumentContentActionbar",
  mixins: [ColorMixin],
  components: {
    DocumentSearchView, DocumentPathView
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "isSearching",
      "currentPath"
    ]),
    isRootDirectory () {
      return this.currentPath.length === 0
    },
  },
  methods: {
    isSearchView () {
      return this.isSearching && !this.isRootDirectory
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
</style>